import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useNoParcelsCopy = () => {
  const { t, isLoggedIn } = useGlobalState();
  const { get: getAnonymous, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  const fallback = {
    noParcelsAdded: t(MasterTranslation.NoParcelsAdded),
    noParcelsFound: t(MasterTranslation.NoParcelsFound),
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const get = isLoggedIn ? getSignedIn : getAnonymous;

  return {
    noParcelsAdded: get('no_parcels_added', fallback.noParcelsAdded),
    noParcelsFound: get('no_parcels_found', fallback.noParcelsFound),
  };
};
